export class CreateEditHostingShortcutParam {
  constructor(params) {
    this.shortcutId = params.shortcutId || 0
    this.name = params.name || ''
    this.commandId = params.commandId || 0
    this.iconId = params.iconId || 0
  }
}
